import { gql } from "@apollo/client";

export default gql`
  query VendorGovernmentConnections($slug: String!, $cursor: Cursor, $product: ObjectId) {
    company(slug: $slug) {
      _id
      governmentConnectionsCount
      governmentConnections(limit: 21, cursor: $cursor, product: $product) {
        items {
          _id
          slug
          logo
          name
          currency
          budget
          isInnovator
          city {
            _id
            name
            population
            country
            countryName
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
